import axios from 'axios';

const TOKEN_KEY = 'vannhi_admin_token';
const EXPIRY_KEY = 'vannhi_admin_token_expires';

export const saveAdminToken = (token, expiresAt) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRY_KEY, expiresAt);
};

export const clearAdminToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRY_KEY);
};

export const getAdminToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expires = localStorage.getItem(EXPIRY_KEY);
  if (!token || !expires || new Date(expires) <= new Date()) {
    clearAdminToken();
    return null;
  }
  return token;
};

const isAdminUrl = (url = '') => url.includes('/api/admin/') || url.includes('/api/payments/admin/');

axios.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token && isAdminUrl(config.url) && !config.url.includes('/verify-password')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || '';
    if (error.response?.status === 401 && isAdminUrl(url) && !url.includes('/verify-password')) {
      clearAdminToken();
      window.dispatchEvent(new Event('admin-logout'));
    }
    return Promise.reject(error);
  }
);

export const downloadAdminFile = async (url, filename) => {
  const res = await axios.get(url, { responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
};
